import React from 'react'
import { useSelector } from 'react-redux'
import { arClass } from '../../../utils/useArClass';

export default function Footer() {
  const darkMode =useSelector(state=>state.settings.darkMode)
  const defaultLanguage = useSelector(state => state.settings.defaultLanguage);

  const text ={
    en: "© 2024 Raqib. All rights reserved.",
    fr: "© 2024 Raqib. Tous droits réservés.",
    ar: "© 2024 Raqib. جميع الحقوق محفوظة."
  }
  return (
    <div className={arClass('flex gap-8 p-3 mt-10 max-md:flex-col')}>
    <h4 className={arClass(`max-sm:text-sm ${darkMode&& "text-white"}`)}>{text[defaultLanguage]}</h4>
  </div>
  )
}
